import styled from 'styled-components';

export const StreamWrapper = styled.div`
  h2::selection,
  div::selection {
    color: #1866dc;
    background-color: #fff;
  }
`;
